import { useEffect, useState } from "react";
import api from "../../../../../../features/auth/axiosConfig";
import { custData } from "src/shared/services/interface";

export function useCustomer(customerId?: string) {
  const [clientId, setClientId] = useState<string>("0000");
  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState<custData>(); // Add this to store full customer data

  useEffect(() => {
    if (!customerId) return;

    const fetchCustomer = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/app/v1/pos/customer?id=${customerId}`);
        const result = res.data.result || {};
        let formattedId = "0000";

        if (result.customer_ref_id) {
          formattedId = String(result.customer_ref_id).padStart(4, "0");
        }
        setClientId(formattedId);
        setCustomerData(result); // Store the full customer data
      } catch (error) {
        console.error("Error fetching customer:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, [customerId]);

  const updateEmail = async (customerId: string, payload: any) => {
    return api.put(`/app/v1/pos/customer/${customerId}`, payload);
  };

  return { clientId, loading, updateEmail, customerData }; // Return customerData
}
